import { useEffect, useState, useContext, useRef } from "react";
import styled from "styled-components";
import { DataContext } from "../context/DataContext";

const MatrixLabel = ({
  pageQuestions,
  setOtherErrors,
  questionsLength,
  question,
  index,
  answeredQuestions,
  setAnsweredQuestions,
  setCurrentPageAnswers,
  currentPage,
  errors,
  setErrors,
  toDisplay,
  parseDynamicQuestionText
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState();

  useContext(DataContext);

  const [hoveredInput, setHoveredInput] = useState(null);  

  useEffect(() => {
    let answeredQuestionsCopy = [...answeredQuestions];
    let foundAnswerExpression = null;
    if (toDisplay && answeredQuestionsCopy[currentPage - 1]?.length) {
      foundAnswerExpression = question.Answers.find((answer) =>
        answeredQuestionsCopy[currentPage - 1]?.includes(answer.Expression)
      );

      answeredQuestionsCopy[currentPage - 1] = answeredQuestionsCopy[currentPage - 1].map(answeredQuestions => answeredQuestions.replace('=null', '=-998'))
    } else {

      answeredQuestionsCopy[currentPage - 1] = pageQuestions.map(questionObj => questionObj.Answers[0].Expression.replace('=1', '=-998'))
    }                           

      setAnsweredQuestions(answeredQuestionsCopy)
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1])
  
      if (foundAnswerExpression) {
        setSelectedAnswer(foundAnswerExpression.Expression);
      }

  }, [currentPage]);


  const chooseAnswer = (e, index, answerIndex) => {
    e.stopPropagation()
    let answeredQuestionsCopy = [...answeredQuestions];
     
    if (answeredQuestionsCopy[currentPage - 1]) {
                                                          
      answeredQuestionsCopy[currentPage - 1] = answeredQuestionsCopy[currentPage - 1].map(answeredQuestionCode => answeredQuestionCode.replace('=null', '=-998'))

      answeredQuestionsCopy[currentPage - 1][answeredQuestionsCopy[currentPage - 1].findIndex(ans => ans.split('=')[0] === question.Answers[answerIndex].Expression.split('=')[0])] = question.Answers[answerIndex].Expression
    } else {
      answeredQuestionsCopy[currentPage - 1] = pageQuestions.map(questionObj => questionObj.Answers[0].Expression.replace('=1', '=-998'))

      answeredQuestionsCopy[currentPage - 1][answeredQuestionsCopy[currentPage - 1].findIndex(ans => ans.split('=')[0] === question.Answers[answerIndex].Expression.split('=')[0])] = question.Answers[answerIndex].Expression;
    }

    setSelectedAnswer(question.Answers[answerIndex].Expression)            

    setAnsweredQuestions(answeredQuestionsCopy);
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);

    setOtherErrors([]);
    setErrors(
      errors.filter(
        (error) =>
          error !== question.QuestionCode &&
          error !== question.Answers[answerIndex].Expression
      )
    );
  };

  const spanRef = useRef(null);

  const [height, setHeight] = useState(null);

  useEffect(() => {
    if (spanRef.current) {
      const thHeight = spanRef.current.offsetHeight;
      setHeight(thHeight);
    }
  }, []);

  useEffect(() => {
    if (spanRef.current) {
      setHeight(spanRef.current.offsetHeight);
    }
  }, [`${spanRef?.current?.offsetHeight}`]);

  window.addEventListener("resize", () => {
    if (spanRef.current) {
      setHeight(spanRef.current.offsetHeight);
    }
  });


  useEffect(() => {
    if (spanRef.current) {
      setHeight(spanRef.current.offsetHeight);
    }

  }, [currentPage]);  

  return (
    <>
      {index === 0
        ? question.MatrixQuestionContext && (
            <p>{question.MatrixQuestionContext}</p>
          )
        : null}
      {index === 0 ? (
        <StyledH2 dangerouslySetInnerHTML={{ __html: question.QuestionHead
          ? parseDynamicQuestionText(question.QuestionHead, true) 
          : question.QuestionName
          ? parseDynamicQuestionText(question.QuestionName, true)
          : null }}>
        </StyledH2>
      ) : null}
      <Wrapper $index={index}>
        {index % 4 === 0 ? (
          <THead>
            <TR>
              {question.QuestionType !== "SingleRank" && (
                <TH $firstLeft={index === 0} $width="20%"></TH>
              )}
              {question.Answers.map((questionAnswers, i) => (
                <TH
                  $firstRight={i === question.Answers.length - 1}
                  $width={`${
                    question.QuestionType !== "SingleRank"
                      ? 80 / question.Answers.length
                      : 100 / question.Answers.length
                  }%`}
                >{`${
                  question.QuestionType === "MatrixRange"
                    ? i === 0
                      ? "1 - "
                      : i === 3
                      ? "4 - "
                      : i === 6
                      ? "7 - "
                      : ""
                    : question.QuestionType === "SingleRank"
                    ? i === 0
                      ? "1 - "
                      : i === question.Answers.length - 1
                      ? `${i + 1} - `
                      : ""
                    : ""
                }${questionAnswers.AnswerLabel}`}</TH>
              ))}
            </TR>
          </THead>
        ) : null}
        {parseDynamicQuestionText(question.QuestionName, true) && parseDynamicQuestionText(question.QuestionName, true) !== "undefined" && <TBody $height={height < 60 ? "62px" : `${height}px`}>
          <TR>
            {question.QuestionType !== "SingleRank" && (
              <BodyTh
                $width="20%"
                $isEven={index % 2 === 0}
                $height={height < 60 ? "62px" : `${height}px`}
                $bottomLeft={index === questionsLength - 1}
              >
                <StyledSpan dangerouslySetInnerHTML={{ __html: parseDynamicQuestionText(question.QuestionName, true)}} $errors={errors} $question={question} ref={spanRef}>
                </StyledSpan>
              </BodyTh>
            )}
            {question.Answers.map((answer, answerIndex) => (
              <TD
                $width={`${
                  question.QuestionType !== "SingleRank"
                    ? 80 / question.Answers.length
                    : 100 / question.Answers.length
                }%`}
                $isEven={index % 2 === 0}
                $height={height < 60 ? "62px" : `${height}px`}
                onClick={(e) => {
                  e.stopPropagation()
                  chooseAnswer(e, index, answerIndex)
                }}
              >
                <StyledLabel
                  checked={selectedAnswer === answer.Expression}
                  id={`QAns${answer.AnswerCode.split("A")[1]}_${answerIndex}`}
                  onMouseEnter={(e) => {
                     
                    e.stopPropagation()
                    setHoveredInput(answerIndex)
                  }}
                  onMouseLeave={(e) => {
                     
                    e.stopPropagation()
                    setHoveredInput(null)
                  }}
                >
                  <RadioLabel>
                    <input
                      id={`QAns${answer.AnswerCode.split("A")[1]}_${answerIndex}`}
                      type="radio"
                      checked={selectedAnswer === answer.Expression}
                      name={`question_${answer.AnswerCode.split("A")[1]}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        chooseAnswer(e, index, answerIndex);
                      }}
                    />
                  </RadioLabel>
                  <span></span>
                </StyledLabel>
                {hoveredInput === answerIndex && (
                  <ToolTip>{answer.AnswerLabel}</ToolTip>
                )}
              </TD>
            ))}
          </TR>
        </TBody>}
      </Wrapper>

      <WrapperSmall>
        <TbodySmall>
          <TrSmall>
            <ThSmall $errors={errors} $question={question}>
              <StyledSpan dangerouslySetInnerHTML={{ __html: parseDynamicQuestionText(question.QuestionName, true)}} $errors={errors} $question={question}>
              </StyledSpan>
            </ThSmall>
            {question.Answers.map((answer, answerIndex) => (
              <TdSmall
                key={answerIndex}
                $isEven={answerIndex % 2 === 0}
                onClick={(e) => { e.stopPropagation(); chooseAnswer(e, index, answerIndex); }}
              >
                <StyledLabel 
                  checked={selectedAnswer === answer.Expression}
                  id={`QAns${answer.AnswerCode.split("A")[1]}_${answerIndex}`}
                >
                  <RadioLabelSmall
                    htmlFor={`small_QAns${
                      answer.AnswerCode.split("A")[1]
                    }_${answerIndex}`}
                  >
                  <input
                    id={`small_QAns${
                      answer.AnswerCode.split("A")[1]
                    }_${answerIndex}`}
                    type="radio"
                    checked={selectedAnswer === answer.Expression}
                    name={`question_${question.QuestionNo}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      chooseAnswer(e, index, answerIndex);
                    }}
                  />
                  </RadioLabelSmall>
                  <span></span>
                </StyledLabel>
                <Option errors={errors}>{`${
                  question.QuestionType === "MatrixRange"
                    ? answerIndex === 0
                      ? "1 - "
                      : answerIndex === 3
                      ? "4 - "
                      : answerIndex === 6
                      ? "7 - "
                      : ""
                    : question.QuestionType === "SingleRank"
                    ? answerIndex === 0
                      ? "1 - "
                      : answerIndex === question.Answers.length - 1
                      ? `${answerIndex + 1} - `
                      : ""
                    : ""
                }${answer.AnswerLabel}`}</Option>
                {hoveredInput === answerIndex && (
                  <ToolTipSmall>{answer.AnswerLabel}</ToolTipSmall>
                )}
              </TdSmall>
            ))}
          </TrSmall>
        </TbodySmall>
      </WrapperSmall>
    </>
  );
};

const StyledH2 = styled.h2`
  font-weight: 500;
  color: ${(props) => props.theme.textPrimary};
  & .text-bold {
    font-weight: 700;
  }
`;

/* Fix 1 (gap) + Fix 2 (centering): negative margin collapses QuestionsContainer's
   gap between consecutive rows. Negative horizontal margins let the table break out
   of QuestionsContainer's 768px cap and use the full ContentSection width.
   overflow:visible is required so tooltips aren't clipped and no spurious scrollbar
   appears from sub-pixel rounding. */
const Wrapper = styled.div`
  @media (max-width: 760px) {
    display: none;
  }
  width: calc(100% + 3rem);
  margin-left: -1.5rem;
  overflow: visible;
  margin-top: ${(props) => (props.$index > 0 ? "-2rem" : "0")};
`;

const WrapperSmall = styled.table`
  @media (min-width: 760px) {
    display: none;
  }

  width: 100%;
  max-width: 760px;
`;

/* Fix 2: display:block overrides the default table-header/row-group so width:100%
   resolves against Wrapper instead of a content-sized anonymous table box */
const THead = styled.thead`
  display: block;
  width: 100%;
  height: 62px;
`;

const TBody = styled.tbody`
  display: block;
  width: 100%;
`;

/* Fix 2: width: 100% instead of wrapperWidth */
const TR = styled.tr`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const TH = styled.th`
  flex: 0 0 ${(props) => props.$width};
  width: ${(props) => props.$width};
  box-sizing: border-box;
  min-height: 62px;
  padding: 10px 6px;
  background-color: ${(props) => props.theme.accentPrimary};
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  word-break: break-word;
  border-right: 2px solid ${(props) => props.theme.borderPrimary};
  ${(props) => props.$firstLeft && "border-radius: 4px 0 0 0;"}
  ${(props) => props.$firstRight && "border-radius: 0 4px 0 0;"}
`;

const BodyTh = styled.th`
  flex: 0 0 ${(props) => props.$width};
  width: ${(props) => props.$width};
  box-sizing: border-box;
  overflow: hidden;
  height: ${(props) => props.$height};
  background-color: ${(props) =>
    props.$isEven ? props.theme.bgSecondary : props.theme.bgPrimary};
  color: ${(props) => props.theme.textPrimary};
  font-weight: 400;
  display: flex;
  align-items: center;
  border-right: 2px solid ${(props) => props.theme.borderPrimary};

  > span {
    padding: 10px;
    z-index: 2;
  }
  & .text-bold {
    font-weight: 700;
  }
  ${(props) => props.$bottomLeft && "border-radius: 0 0 0 6px;"}
`;

const TD = styled.td`
  flex: 0 0 ${(props) => props.$width};
  width: ${(props) => props.$width};
  box-sizing: border-box;
  height: ${(props) => props.$height};
  background-color: ${(props) =>
    props.$isEven ? props.theme.bgSecondary : props.theme.bgPrimary};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-right: 2px solid ${(props) => props.theme.borderPrimary};
  cursor: pointer;
  ${(props) => props.$bottomRight && "border-radius: 0 0 6px 0;"}
`;

const StyledLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;

  input {
    opacity: 0;
    position: absolute;
    cursor: pointer;
  }

  span {
    width: 20px;
    height: 20px;
    border: 2px solid ${(props) => props.theme.accentPrimary};
    border-radius: 50%;
    display: inline-block;
    position: relative;
    background-color: ${(props) => props.theme.bgPrimary};
    z-index: 2;
  }

  span::after {
    content: "";
    width: 10px;
    height: 10px;
    background-color: ${(props) => props.theme.accentPrimary};
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  ${(props) =>
    props.checked &&
    `span::after {
    opacity: 1;
  }`}
`;


const RadioLabel = styled.label`
  height: 64px;
  width: 154px;
  position: absolute;
  cursor: pointer;
`;

/* Fix 3 (mobile overflow): width: 100% instead of 760px */
const RadioLabelSmall = styled.label`
  height: 60px;
  width: 100%;
  position: absolute;
  cursor: pointer;
  left: -20px;
`;

const TbodySmall = styled.tbody`
  width: 100%;
  max-width: 760px;
`;

const ThSmall = styled.th`
  height: 40px;
  width: 100%;
  padding: 10px 0;
  background-color: ${(props) => props.theme.accentPrimary};
  display: flex;
  align-items: center;
  > span {
    color: ${(props) =>
      props?.$errors.filter((errorCode) =>
        errorCode.includes(
          `${props?.$question?.Answers[0].AnswerCode.split("=")[0]}=`
        )
      ).length === props?.$question?.Answers.length
        ? props.theme.errorText
        : "white"};
    font-weight: 500;
    padding-left: 10px;
  }
  & .text-bold {
    font-weight: 700;
  }
`;

/* Fix 3 (mobile overflow): width: 100% instead of 760px */
const TdSmall = styled.td`
  height: 60px;
  background-color: ${(props) =>
    props.$isEven ? props.theme.bgSecondary : "transparent"};
  color: ${(props) => props.theme.textPrimary};
  display: flex;
  align-items: center;
  padding: 0px 20px;
  margin: 2px;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: ${(props) => props.theme.bgTertiary};
  }
`;

const TrSmall = styled.tr`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  background-color: ${(props) => props.theme.bgTertiary};
  margin-bottom: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
`;

const Option = styled.span`
  margin-left: 20px;
`;

const StyledSpan = styled.span`
  color: ${(props) =>
    props?.$errors.filter(errorCode => errorCode.includes(`${props?.$question?.Answers[0].AnswerCode.split('=')[0]}=`)).length === props?.$question?.Answers.length
      ? props.theme.errorText
      : props.theme.textSecondary};
  text-align: left;
`;

const ToolTip = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.accentPrimary};
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
  top: -10px;
`;

const ToolTipSmall = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.accentPrimary};
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
  left: 200px;
`;
export default MatrixLabel;
